<template>
    <div class="apprentice-simple-card">
        <b-tabs
            class="group-show-tab apprentice-tab"
            content-class="group-overview"
            fill>
            <b-tab class="new-students">
                <template v-slot:title>{{ $t('common.not_found') }}</template>

                <!-- TODO: Improve translation -->
                {{ $t('group.students_not_found_based_on_their_email_address') }}

                <design-2021-apprentice-data-table
                    class="not_found_table"
                    :items="newStudents"
                    :fields="headers">
                    <template
                        v-slot:cell(add_to_import)="data"
                        v-if="!lasConnectionIn">
                        <div class="add_to_import">
                            <b-button
                                class="btn-hand-pointer btn-user-selection-toggle"
                                :class="data.item.selected && 'active'"
                                variant="primary-icon-only"
                                @click="newUserSelectionToggle(data.item)">
                            </b-button>
                        </div>
                    </template>
                </design-2021-apprentice-data-table>
                <div v-if="lasConnectionIn">
                    <p variant="alarm">
                        {{
                            $t(
                                'group_pair.add_these_students_manually_make_sure_they_do_not_exist_under_a_different_email_address',
                            )
                        }}
                    </p>
                </div>
                <div class="tools">
                    <b-button
                        class="btn-back-to-group-pair"
                        @click="backToGroupPair"
                        variant="outline-primary">
                        {{ $t('group_pair.back_to_groups') }}
                    </b-button>

                    <b-button
                        class="btn-add btn-add-student"
                        v-if="!lasConnectionIn"
                        @click="addSelectedStudents()"
                        variant="primary">
                        {{ $t('common.add') }}
                    </b-button>
                </div>
            </b-tab>
            <b-tab class="existing-students">
                <template v-slot:title>
                    {{ $t('group_pair.found') }}
                </template>
                {{ $t('group_pair.this_students_were_found_based_on_email_address') }}
                <design-2021-apprentice-data-table
                    class="not_found_table"
                    :items="existingStudents"
                    :fields="headers">
                    <template v-slot:cell(add_to_import)="data">
                        <div class="add_to_import">
                            <b-button
                                class="btn-hand-pointer btn-user-selection-toggle"
                                :class="data.item.selected && 'active'"
                                variant="primary-icon-only"
                                @click="existingUserSelectionToggle(data.item)">
                            </b-button>
                        </div>
                    </template>
                </design-2021-apprentice-data-table>
                <div class="tools">
                    <b-button
                        class="btn-back-to-group-pair"
                        @click="backToGroupPair"
                        variant="outline-primary">
                        {{ $t('group_pair.this_students_were_found_based_on_email_address') }}
                    </b-button>

                    <b-button
                        class="btn-add btn-add-student"
                        @click="addExistingStudents()"
                        variant="primary">
                        {{ $t('common.add') }}
                    </b-button>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-pair-import-validate-component',
    props: ['groupIn', 'resultsIn', 'importIn', 'lasConnectionIn'],
    data() {
        return {
            newStudents: [],
            existingStudents: [],
            headers: [
                {
                    key: 'add_to_import',
                    label: this.$t('common.choose'),
                },
                {
                    key: 'name',
                    label: this.$t('common.first_name'),
                    sortable: true,
                },
                {
                    key: 'preposition',
                    label: this.$t('common.infix'),
                    sortable: false,
                },
                {
                    key: 'surname',
                    label: this.$t('common.last_name'),
                    sortable: true,
                },
                {
                    key: 'email',
                    label: this.$t('common.email_address'),
                    sortable: true,
                },
                {
                    key: 'external_id',
                    label: this.$t('common.student_number'),
                    sortable: true,
                },
            ],
        };
    },
    methods: {
        newUserSelectionToggle(user) {
            this.newStudents = this.newStudents.map((student) => {
                if (student.email === user.email) {
                    student.selected = !student.selected;
                }
                return student;
            });
        },
        existingUserSelectionToggle(user) {
            this.existingStudents = this.existingStudents.map((student) => {
                if (student.id === user.id) {
                    student.selected = !student.selected;
                }
                return student;
            });
        },
        addExistingStudents() {
            const data = {
                students: this.existingStudents.filter((user) => user.selected),
            };
            axios.post(this.routes.groupPairImportExistingUsers(this.groupIn.id, this.importIn.id), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        addSelectedStudents() {
            const data = {
                students: this.newStudents.filter((user) => user.selected),
            };

            axios.post(this.routes.groupPairImportValidate(this.groupIn.id, this.importIn.id), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        backToGroupPair() {
            localStorage.setItem('tab', 'studentsLeft');
            window.location.href = this.routes.groupInvitesCheck(this.groupIn.id);
        },
    },

    mounted() {
        this.newStudents = this.resultsIn[0].map((user) => {
            user.selected = false;
            user.type_name = 'student';
            return user;
        });
        this.existingStudents = this.resultsIn[1].map((user) => {
            user.selected = false;
            return user;
        });
    },
};
</script>

<style scoped lang="scss">
.not_found_table ::v-deep {
    .add_to_import {
        .btn-user-selection-toggle {
            color: grayscale($primary);

            &.active {
                color: $primary;
            }
        }
    }
}

::v-deep .apprentice-data-table tbody .btn-new-paper {
    font-size: 28px;
}

.tools {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    .btn {
        line-height: 1;
    }

    .btn-add-student {
        &:nth-child(2) {
            margin-left: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}
</style>
